<template>
  <div class="cart orderList">
    <h1 class="boxTitle mb15 notranslate">{{locale.payment_list}}</h1>
    <div v-if="paymentList.length" class="list">
      <PaymentListItem
        v-for="item in paymentList"
        :key="item.orderId"
        :itemList="item"
        :locale="locale"
        :lang="lang"
        @deleteItem="deleteItem" />
    </div>
    <div v-else class="noData notranslate">{{locale.payment_nodata}}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PaymentListItem from '@/components/Mypage/PaymentListItem'

export default {
  name: 'PaymentList',
  props: [
    'lang',
    'locale'
  ],
  components: {
    PaymentListItem
  },
  computed: {
    ...mapGetters({
      metaInfo: 'authentication/getMetaInfo'
    }),
    paymentList () {
      const list = this.list.map(x => x)
      return list.sort((a, b) => a.createat > b.createat ? -1 : a.createat < b.createat ? 1 : 0)
    }
  },
  async mounted () {
    await this.getKey()
    await this.getOrderHistory()
  },
  data () {
    return {
      list: [],
      moreCount: 0,
      next: null,
      space: this.$store.state.authentication.space,
      key: this.$store.state.authentication.k
    }
  },
  methods: {
    track () {
      const site = this.$store.state.authentication.site
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      this.$gtag.pageview({
        page_path: path,
        page_title: 'paymentList'
      })
    },
    async getKey () {
      if (this.isPublic) {
        const res = await this.$store.dispatch('authentication/getOtaKey')
        this.key = res
      }
    },
    init () {
      this.track()
    },
    async getOrderHistory () {
      this.$store.commit('loading', true)
      const next = this.next
      const mypageType = this.$route.name.replace('my', '').toLowerCase()
      const data = {
        mypageType: mypageType,
        paging: {
          limit: 30,
          ...next && {
            next: next
          }
        }
      }
      const history = await this.$store.dispatch('guest/getMypageHistory', data)
      if (history && history.items) {
        this.list = this.list.map(x => {
          return {
            ...x,
            firstItem: false
          }
        }).concat(history.items.map((x, i) => {
          return {
            ...x,
            firstItem: i === 0 // 새로 불러온 첫 아이템으로 스크롤 하기 위한 flag
          }
        }))
      }
      this.$store.commit('loading', false)
      this.next = (history && history.next) || null
      this.scrollList()
      return history
    },
    scrollList () {
      this.$nextTick(() => {
        const list = this.$refs.mypageList
        const firstItem = document.querySelector('.firstItem')
        if (firstItem && this.moreCount > 0) {
          const top = firstItem.offsetTop
          const height = firstItem.offsetHeight
          window.scrollTo({
            top: top,
            behavior: 'smooth'
          })
        }
        this.moreCount += 1
      })
    },
    deleteItem (orderId) {
      const authInfo = this.$store.state.authentication
      const metaInfo = {
        siteid: authInfo.site,
        metakey: authInfo.metakey,
        ota: authInfo.k
      }
      this.$store.commit('loading', true)
      this.$store.dispatch('payment/delOrders', { ...metaInfo, orderId: orderId }).then((res) => {
        if (res) {
          alert(this.locale.complete_delete)
          this.$store.dispatch('submit/getOrderHistory').then((res) => {
            this.list = res.paidLog || []
          })
        }
        this.$store.commit('loading', false)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.noData {
  padding: 90px 0;
  text-align: center;
}
</style>
